// !IMPORTANT - this assumes that you're under 900px in VIEW PORT WIDTH
import Glide from '@glidejs/glide';
import _throttle from 'lodash/throttle';
import _inRange from 'lodash/inRange';
import { updateMediaGrid } from './pdp-media';
import Alpine from 'alpinejs';

export const initFusionPdpSlider = () => {
    // wrapper of the entire media grid
    const mediaContainer = document.getElementById('fusionMediaCore');
    const sliderTrack = document.getElementById('fusionSliderTrack');
    const slidesWrapper = document.getElementById('fusionMediaInnerWrapper');
    const slides = document.getElementById('fusionMediaItem');

    // on the wrrapper remove grid clas - this will make the slider NOT display
    slidesWrapper.classList.remove('fusion-pdp__media-grid')

    mediaContainer.classList.add('customSlider') // REQUIRED init class for slider 
    sliderTrack.classList.add('glide__track') // REQUIRED track  - data elm stays on markup 
    slidesWrapper.classList.add('glide__slides') // REQUIRED this wraps all individual slides
    if (slides !== null) {
    slides.classList.add('glide__slide') // REQUIRED individual slide wrapper class
    }


    let sliderGlider = new Glide('.customSlider',
        {
            type: 'slider',
            startAt: 0,
            perView: 1,
            rewind: false,
            touchRatio: .8,
            perTouch: 1,
            direction: 'ltr',
            focus: 'center',
            gap: 10
        }
    )
    sliderGlider.mount();
    window.fusionDataLayer.activeSlider = true;
    window.fusionElements.pdpMobileSlider = sliderGlider;

    let swipeStartX = 0,
        swipeStartY = 0,
        slider = document.querySelector('.customSlider');

    // e passes touch event data
    slider.addEventListener('touchstart', _throttle((e) => {
        swipeStartX = e.pageX;
        swipeStartY = e.pageY;
    }));

    slider.addEventListener('touchmove', _throttle((e) => {
        let angle = Math.floor(Math.atan2(e.pageY - swipeStartY, e.pageX - swipeStartX) * 180 / Math.PI)

        if (_inRange(angle, 100, 178) || _inRange(angle, 0, 85) || _inRange(angle, 0, -60)) {
            e.preventDefault(); // prevent slide from changing
        } else {
            return true
        }
    }, { passive: false }), 2);
}

// vpw = view port width - called by index on resize
export const handleVpChange = (vpw) => {

    if (vpw <= 900 && window.fusionDataLayer.activeSlider === false) {
        initFusionPdpSlider();
    } else {
        if (vpw > 900 && window.fusionDataLayer.activeSlider === true) {            
            //! Destroy glide instance - must be first
            window.fusionElements.pdpMobileSlider.destroy();

            // wrapper of the entire media grid
            const mediaContainer = document.getElementById('fusionMediaCore');
            const sliderTrack = document.getElementById('fusionSliderTrack');
            const slidesWrapper = document.getElementById('fusionMediaInnerWrapper');
            const slides = document.getElementById('fusionMediaItem');

            // on the wrrapper remove grid clas - this will make the slider NOT display
            slidesWrapper.classList.add('fusion-pdp__media-grid')

            // remove slider class name artifacts
            mediaContainer.classList.remove('customSlider') // REQUIRED init class for slider 
            sliderTrack.classList.remove('glide__track') // REQUIRED track  - data elm stays on markup 
            slidesWrapper.classList.remove('glide__slides') // REQUIRED this wraps all individual slides
            slides.classList.remove('glide__slide') // REQUIRED individual slide wrapper class

            updateMediaGrid(Alpine.store('activeProduct').activeProduct.images, Alpine.store('activeProduct').activeProduct);

            window.fusionDataLayer.activeSlider = false;
        }
        else {
            return;
        }
    }
}